<!-- 首轮/次轮分配结果表 -->
<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <ls-search-form :formList="formList" @search="onSearch" @reset="resetQuery"  ref="refSearchForm">
        <a-month-picker
          style="width:100%"
          slot="monthYear"
          format="YYYY-MM"
          valueFormat="YYYYMM"
          placeholder="请选择日期"
          v-model="queryParams.monthYear" />
      </ls-search-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiScpMpsSuppliesFdExport" ref="download" />
      <a-button type="primary" @click="handleExport" v-if="$hasPermi(['fun_1833472253848801281_euCyb'])">导出</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1300 }"
        >
          <template slot="createTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
        </ls-api-table>
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { apiScpMpsSuppliesFdExport, apiSelectSuppliesFdPageList } from '@/api/finished-goods-order'

import { generateLsTableResData } from '@/utils/util.js';
import cloneDeep from 'lodash.clonedeep'
import DownloadModal from '@/views/components/download-modal/download-modal.vue'
export default {
  // eslint-disable-next-line
  name: 'First-or-second-round-allocation', // name要和rms配置菜单路由保存一致(首字母大写)
  components: {
    DownloadModal
  },
  data () {
    return {
      apiScpMpsSuppliesFdExport,
      warehouseOptions: [],
      // 表格配置
      tableProps: {
        requestApi: generateLsTableResData(apiSelectSuppliesFdPageList, true),
        pageCurrent: true
      },
      isEdit: false,
      currentId: "",
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        supplierCode: undefined,
        supplierName: undefined,
        supplierClass: undefined,
        supplierAbbreviation: undefined,
        supplierBrevityCode: undefined,
        itemCodeList: undefined,
        monthYear: undefined
      },
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      formList: [
        {
          label: '周版本号',
          type: "globalSelect-selectSearch",
          decorator: ['weekPlanVersion'],
          attrs: {
            placeholder: '请选择周版本号',
            requestApi: '/scp/scpMpsSuppliesFd/findWeekVersion',
            selectItem: { value: 'selectedValue', label: 'label' },
            searchParam: 'weekPlanVersion'
          }
        },
        {
          label: '计划版本号',
          type: "globalSelect-selectSearch",
          decorator: ['version'],
          attrs: {
            placeholder: '请选择计划版本号',
            requestApi: '/scp/scpMpsSuppliesFd/findVersionList',
            selectItem: { value: 'selectedValue', label: 'label' },
            searchParam: 'version'
          }
        },
        {
          label: '阶段',
          type: "select",
          decorator: ['status'],
          options: [{ value: '首轮分配执行完成', key: 'FIRST_ALLOCATION' }, { value: '次轮分配执行完成', key: 'SECOND_ALLOCATION' }],
          attrs: {
            placeholder: '请选择阶段'
          }
        },
        {
          label: '物料编码',
          type: "globalSelect-selectAssembleMultipleSearch",
          decorator: ['itemCodeList'],
          attrs: {
            placeholder: '请选择物料编码',
            requestApi: '/mes/mesDiscreteJobs/assemblyBox',
            selectItem: { value: 'selectedValue', label: 'bringOutDataOne' },
            searchParam: 'itemCode'
          }
        },
        { label: '月份', decorator: ['monthYear'], type: 'monthYear' }
      ],
      // 表格字段
      columns: [
        {
          title: '周版本号',
          dataIndex: 'weekPlanVersion',
          fixed: 'left',
          align: 'center',
          ellipsis: true,
          width: 140
        },
        {
          title: '计划版本号',
          width: 220,
          dataIndex: 'version',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '月度计划版本号',
          dataIndex: 'monthPlanVersion',
          ellipsis: true,
          align: 'center',
          width: 150
        },
        {
          title: '阶段',
          dataIndex: 'status',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '分配供应商',
          dataIndex: 'supplierName',
          ellipsis: true,
          width: 220,
          align: 'center'
        },
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '物料名称',
          dataIndex: 'itemName',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '是否独供',
          dataIndex: 'exclusiveConfession',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '分配量',
          dataIndex: 'newOrderQuantity',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '配置分组',
          dataIndex: 'matchingGroup',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '月份',
          dataIndex: 'supplyDate',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '创建人',
          dataIndex: 'createName',
          ellipsis: true,
          width: 150,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          ellipsis: true,
          width: 150,
          align: 'center'
        }
      ],
      uomClassOptions: [], // 来源分类
      unitOfMeasureList: [], // 来源单位
      unitOfMeasureListNew: [] // 基本单位
    }
  },
  created () {
  },
  mounted () {
    this.onSearch()
  },
  methods: {
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      this.$nextTick(() => {
        // const params = { ...this.queryParams }
        const params = this.$refs.dataTable.searchParams
        this.$refs.download.openModal(params)
      })
    },
    // 表单搜索
    onSearch (val) {
      // this.queryParams = {};
      // for(const key in val) {
      //   if(key !== 'searchFormLabel') {
      //     this.queryParams[key] = val[key]
      //   }
      // }
      const params = Object.assign({}, this.queryParams, val)
      delete params.searchFormLabel
      this.$refs.dataTable.searchParams = cloneDeep(params);
      this.$refs.dataTable.getData();
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        uomClassList: undefined,
        unitOfMeasureList: undefined,
        baseUomList: undefined,
        status: undefined,
        itemCodeList: undefined,
        monthYear: undefined
      }
      this.$refs.dataTable.searchParams = this.queryParams
      this.$refs.refSearchForm.form.setFieldsValue(this.queryParams)
      this.onSearch()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
/deep/.ant-modal-body{
  height: 400px;
  overflow-y: scroll;
}
</style>
